import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

import {ErrorResponse} from '../../../../data/model/errorResponse';
import {OrganisationsDataManager} from '../../../../data/organisations.datamanager';
import {UploadDataManager} from '../../../../data/upload.datamanager';

@Component({
  selector: 'add-organisation-dialog',
  templateUrl: './add-organisation-dialog.html'
})
export class AddOrganisationDialogComponent {
  name = '';
  licenceAmount = '';
  has_anonymised_progress = false;
  is_allowed_to_save_progress = true;
  has_anonymised_exam_results = false;
  is_allowed_to_save_exam_results = true;
  administrator_mail_address = '';
  value = 0;
  showProgress = false;
  image: File = null;
  statusText = 'starting upload';

  amountInput = new FormControl(
      '', [Validators.pattern('^[0-9]*$'), Validators.required]);
  nameInput = new FormControl('', [Validators.required]);
  administratorMailAddressInput = new FormControl('', [Validators.required]);

  constructor(
      private uploadDataManager: UploadDataManager,
      private organisationsDataManager: OrganisationsDataManager,
      public dialogRef: MatDialogRef<AddOrganisationDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  handleImageInput(files: FileList) {
    this.image = files.item(0);
  }

  onAddClick(name: string) {
    this.statusText = 'Uploading image';
    this.value = 0;
    this.uploadDataManager.getSignedUpload(this.image.name, this.image.type)
        .subscribe(
            (imageSignedResponse) => {
              this.uploadDataManager
                  .uploadFileToS3(imageSignedResponse, this.image)
                  .subscribe(
                      (imageResponse) => {
                        if (typeof imageResponse === 'string') {
                          this.organisationsDataManager
                              .createOrganisation(
                                  this.name, this.licenceAmount,
                                  imageSignedResponse.url, this.has_anonymised_progress, this.administrator_mail_address)
                              .subscribe(
                                  (res) => {
                                    this.closeDialogSuccess(
                                        'succesfully created the organisation');
                                  },
                                  (err) => {
                                    console.log(err);
                                    this.closeDialogWithError(err.json());
                                  });
                        } else {
                          this.value = imageResponse;
                        }
                      },
                      (err) => {
                        console.log(err);
                        this.closeDialogWithError(err.json());
                      });
            },
            (err) => {
              console.log(err);
              this.closeDialogWithError(err.json());
            });
  }

  getErrorMessage() {
    return this.amountInput.hasError('required') ?
        'You must enter an amount' :
        this.amountInput.hasError('pattern') ? 'Not a valid number' : '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  openImageUpload() {
    document.getElementById('image-id').click();
  }

  closeDialogWithError(error: ErrorResponse) {
    this.dialogRef.close(error);
  }

  closeDialogSuccess(message: string) {
    this.dialogRef.close(message);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/add/add.organisation.dialog.component.ts